import * as DAOUtils from "../utils/DAOUtils";

export function getManufacturers() {
  return DAOUtils.get("/manufacturers");
}
